<label
  *ngIf="labelText"
  [htmlFor]="id"
  [ngClass]="isDisabled ? 'eq-form-label-top--disabled' : ''"
>
  {{ labelText }}
</label>
<small *ngIf="helperText" class="eq-text-body-xs-m lg:eq-text-body-xs eq-text-blue-darkBlue" [ngClass]="isDisabled ? 'eq-form-label-top--disabled' : ''">{{helperText.includes('@@MessageCharLength@@') ? helperText.replace('@@MessageCharLength@@', +maxLength-value?.length) : helperText}}</small>
<textarea
  [id]="id"
  [name]="name"
  rows="{{ rows }}"
  [placeholder]="placeholder"
  [required]="isRequired && error"
  [attr.maxlength]="maxLength"
  [disabled]="isDisabled"
  [value]="value"
  (input)="onValueChange($event.target.value)"
  class="eq-form-textarea"
  [ngClass]="error ? 'invalid' : ''"
></textarea>
<small *ngIf="error" class="eq-text-sm eq-mt-2 eq-text-red-brandRed-hover">
  {{errorText}}
</small>
